import type { FiltersInput, PageableRangeInput, RateInput } from '@allocab/allocab-extranet-api-types';

import type { GlobalFiltersState } from '../../components/filters/filterStore';

/**
 * Sous-ensemble "data" du store filtres — c'est tout ce que les mappers lisent.
 * Permet de passer aussi bien le store complet (avec setters zustand) qu'un
 * DashboardRateInput (où entityIds/contractIds/siteIds sont optionnels).
 */
type FiltersData = {
  entityIds?: GlobalFiltersState['entityIds'];
  contractIds?: GlobalFiltersState['contractIds'];
  siteIds?: GlobalFiltersState['siteIds'];
  dateRange: GlobalFiltersState['dateRange'];
};

/**
 * Mapping interne → contrat back :
 * - entityIds  → accountKeys
 * - contractIds → ctr
 * - siteIds    → bupo
 * - dateRange.{from,to} ISO → startDate/endDate timestamps (ms)
 */
export const toFiltersInput = (filters: FiltersData): FiltersInput => ({
  accountKeys: filters.entityIds?.length ? filters.entityIds : undefined,
  ctr: filters.contractIds?.length ? filters.contractIds : undefined,
  bupo: filters.siteIds?.length ? filters.siteIds : undefined,
});

export const toRateInput = (filters: FiltersData): RateInput => ({
  ...toFiltersInput(filters),
  startDate: new Date(filters.dateRange.from).getTime(),
  endDate: new Date(filters.dateRange.to).getTime(),
});

export const toPageableRangeInput = (
  filters: FiltersData,
  page?: { offset?: number; limit?: number },
): PageableRangeInput => ({
  ...toRateInput(filters),
  offset: page?.offset,
  limit: page?.limit,
});
